<div class="home-container">
    <div class="home-header">
        
        <div class="home-header-left">
            <img class="f-logo" src="../../../assets/f_logo.png" alt="logo" mat-card-avatar>
            <div class="input">
                <div class="fas fa-search icon-search"></div>
                <input class="input-search" type="text" placeholder="Search Fakebook">
            </div>
        </div>
        
        <div class="home-header-middle">
            <!-- <div></div> -->
            <div class="hoverable-icon" (click)="changeActiveTab('home')"
            [ngClass]="isActiveTab('home')?'active':''">
                <i class="fas fa-home"></i>
            </div>
            <div class="hoverable-icon" (click)="changeActiveTab('video')"
            [ngClass]="isActiveTab('video')?'active':''">
                <i class="fas fa-video"></i>
            </div>
            <div class="hoverable-icon" (click)="changeActiveTab('store')"
            [ngClass]="isActiveTab('store')?'active':''">
                <i class="fas fa-store"></i>
            </div>
            <div class="hoverable-icon" (click)="changeActiveTab('users')"
            [ngClass]="isActiveTab('users')?'active':''">
                <i class="fas fa-users"></i>
            </div>
            <div class="hoverable-icon" (click)="changeActiveTab('flag')"
            [ngClass]="isActiveTab('flag')?'active':''">
                <i class="fas fa-flag"></i>
            </div>
        </div>

        <div class="home-header-right">
            <div class="right-avatar-div">
                <img class="right-avatar" [src]="user?.avatar" alt="{{ user?.avatar }}" mat-card-avatar>
                <span class="name">{{ user?.firstName }}</span>
            </div>
            
            <div class="right-icons-container">
            <div class="right-icons">
                <div>
                    <i class="fas fa-plus right-icon"></i>
                </div>
                <div>
                    <i class="fas fa-comments badge-comment right-icon"></i>
                </div>
                <div>
                    <i class="fas fa-bell right-icon"></i>
                </div>
                <!-- MENU BUTTON -->
                <div> 
                    <i class="fas fa-caret-down right-icon" [matMenuTriggerFor]="menu"></i>
                    <mat-menu #menu="matMenu">
                        <div class="right-avatar-menu-div">
                            <div class="right-avatar-menu">
                                <img class="right-avatar-menu-avatar" [src]="user?.avatar" alt="{{ user?.avatar }}" mat-card-avatar>
                                <div class="right-avatar-menu-profile">
                                    <span class="right-avatar-menu-name">{{ user?.firstName }} {{ user?.lastName }}</span>
                                    <span class="right-avatar-menu-see">See your profile</span>
                                </div>
                            </div>
                            <mat-divider></mat-divider>
                            <!-- <hr class="right-avatar-menu-hr"> -->
                            <!-- <button mat-menu-item (clicked)="logOut()"> -->
                                <div class="right-avatar-menu-logout" (click)="logOut()">
                                    <i class="fas fa-sign-out-alt right-avatar-menu-logout-icon"></i>
                                    <span class="right-avatar-menu-logout-text">Log out</span>
                                </div>
                                <!-- </button> -->
                        </div>
                    </mat-menu>
                </div>
            </div>
        </div>
        </div>
    </div>

    <!-- LEFT BAR -->
    <div class="home-body">
        <div class="home-body-left">
            <div class="inside">
                <div class="user-avatar">
                    <img [src]="user?.avatar" alt="{{ user?.avatar }}" mat-card-avatar>
                    <span class="name">{{ user?.firstName }} {{ user?.lastName }}</span>
                </div>
                
                <div class="body-left">
                    <i class="fas fa-notes-medical fa-fw body-left-icon"></i>
                    <div class="body-left-2lines">
                        <span>Covid-19 Information Center</span>
                        <div class="body-left-notification">
                            <h5>
                                <i class="fas fa-circle fa-xs"></i>
                                &nbsp;1 notification
                            </h5>
                        </div>
                    </div>
                </div>
                <div class="body-left">
                    <i class="far fa-flag fa-fw body-left-icon"></i>
                    <span>Pages</span>
                </div>
                <div class="body-left">
                    <i class="fas fa-user-friends fa-fw body-left-icon"></i>
                    <div class="body-left-2lines">
                        <span>Friends</span>
                        <div class="body-left-notification">
                            <h5>
                                <i class="fas fa-circle fa-xs"></i>
                                &nbsp;2 requests
                            </h5>
                        </div>
                    </div>
                </div>
                <div class="body-left">
                    <i class="fas fa-comment fa-fw body-left-icon"></i>
                    <span>Messenger</span>
                </div>
                <div class="body-left">
                    <i class="fas fa-store fa-fw body-left-icon"></i>
                    <span>Marketplace</span>
                </div>
                <div class="body-left">
                    <i class="fas fa-film fa-fw body-left-icon"></i>
                    <span>Videos</span>
                </div>
                <div class="body-left">
                    <i class="far fa-calendar-alt fa-fw body-left-icon"></i>
                    <span>Events</span>
                </div>
                <div class="body-left">
                    <i class="fas fa-history fa-fw body-left-icon"></i>
                    <span>Memories</span>
                </div>
                <div class="body-left">
                    <i class="far fa-bookmark fa-fw body-left-icon"></i>
                    <span>Saved</span>
                </div>
                <div class="body-left">
                    <i class="fas fa-angle-down fa-fw body-left-see-more"></i>
                    <span>See more</span>
                </div>
                <div>
                    <hr>
                </div>
            </div>
        </div>
        
        <div class="home-body-middle">

            <!-- STORIES -->
            <div class="stories">
                <div class="story-card" *ngFor="let i of stories">
                    <img class="story-card-img" src="{{ i?.url }}" alt="{{ i?.name }}">
                    <div class="story-card-name " [ngClass]="i?.name.length <= 12 ? 'story-card-name-pos' : 'story-card-name-pos2'" >
                        {{ i?.name }}
                    </div>
                    <!-- {{ i | json }} -->
                </div>
            </div>
            
            
            <!-- POST SOMETHING -->
            <mat-card class="home-body-middle-post-something">
                <mat-card-header class="card-header">
                    <img class="avatar" [src]="user?.avatar" alt="{{user?.avatar}}" mat-card-avatar>
                    <div class="fake-form" (click)="createPost()">What's on your mind {{user?.firstName}}?</div>
                </mat-card-header>
                <mat-card-content class="card-body">
                    <div class="card-body-buttons">
                        <i class="fas fa-video text-danger fa-lg fa-fw card-body-icon"></i>
                        <span class="text-secondary card-body-text">Live video</span>
                    </div>
                    <div class="card-body-buttons">
                        <i class="fas fa-photo-video text-success fa-lg fa-fw card-body-icon"></i>
                        <span class="text-secondary card-body-text">Photo/Video</span>
                    </div>
                    <div class="card-body-buttons">
                        <i class="fas fa-smile text-warning fa-lg fa-fw card-body-icon"></i>
                        <span class="text-secondary card-body-text">Feeling/Activity</span>
                    </div>
                </mat-card-content>
            </mat-card>

            <!-- LIST OF POSTS -->
            <div class="posts">
                <!-- <img class="test" src="../../../assets/buzz_lightyear.jpg" alt=""> -->
                <mat-card class="post" *ngFor="let p of posts">
                    <mat-card-header class="post-card-header">
                        <div class="post-card-header-left">
                            <img class="avatar" [src]="p?.avatar" alt="{{ p?.avatar }}" mat-card-avatar>
                            <div class="post-name-time">
                                <span class="post-name">{{ p?.firstName }} {{p?.lastName}}</span>
                                <span class="post-time" ngbTooltip="{{ p?.time?.toDate() | date : 'EEEE, MMMM d, y h:mm' }}" placement="bottom">
                                    {{ p?.time?.toDate() | timeAgo }}
                                </span>
                            </div>
                        </div>
                        <div class="post-card-header-right" *ngIf="isPostFromUser(p, this.user)">
                            <i class="fas fa-ellipsis-h fa-fw post-card-header-right-edit" [matMenuTriggerFor]="editPostMenu"></i>
                            <mat-menu class="test" #editPostMenu="matMenu" xPosition="before" yPosition="above">
                                <div class="edit-post-menu">
                                    <div class="edit-post-menu-button" (click)="editPost(p)">
                                        <i class="fas fa-pen fa-fw edit-post-menu-icon"></i>
                                        <div class="edit-post-menu-text">
                                            <span class="edit-post-menu-title">Edit post</span>
                                            <span class="edit-post-menu-desc">Make some modifications to the post.</span>
                                        </div>
                                    </div>
                                    <mat-divider class="edit-post-menu-divider"></mat-divider>
                                    <div class="edit-post-menu-button" (click)="deletePost(p)">
                                        <i class="far fa-trash-alt fa-fw edit-post-menu-icon"></i>
                                        <div class="edit-post-menu-text">
                                            <span class="edit-post-menu-title">Move to Trash</span>
                                            <span class="edit-post-menu-desc">Be careful, this operation cannot be undone.</span>
                                        </div>
                                    </div>
                                </div>
                            </mat-menu>
                        </div>
                    </mat-card-header>
                    <mat-card-content class="post-card-body">
                        <div class="post-text">
                            {{ p?.message }}
                            <!-- {{ p | json }} -->
                        </div>
                        <div class="post-image-wrapper" *ngIf="p?.imageUrl">
                            <a [href]="p?.imageUrl" target="_blank">
                                <img class="post-image" [src]="p?.imageUrl" [alt]="p?.imageName">
                            </a>
                        </div>
                    </mat-card-content>
                    <mat-card-footer class="post-card-footer">
                        <div class="post-likes" *ngIf="p?.likes.length > 0">
                            <i class="fas fa-thumbs-up thumbs-up-liked"></i>
                            <span class="likes-number" [ngbTooltip]="tipLikes" tooltipClass="new-message-tip">{{ p?.likes.length }}</span>
                            <ng-template #tipLikes>
                                <div *ngFor="let liker of getUsersThatLikedPost(p)">
                                    <span>{{ liker }}</span>
                                </div>
                            </ng-template>
                        </div>
                        <div class="post-buttons">
                            <div class="post-button" [ngClass]="isPostLikedByUser(p, this.user) ? 'blue' : ''" (click)="likePost(p)">
                                <i class="fa-thumbs-up fa-fw fa-lg post-button-like" [ngClass]="isPostLikedByUser(p, this.user) ? 'fas' : 'far'"></i>
                                Like
                            </div>
                            <div class="post-button">
                                <i class="far fa-comment fa-fw fa-lg"></i>
                                Comment
                            </div>
                            <div class="post-button">
                                <i class="far fa-share-square fa-fw fa-lg"></i>
                                Share
                            </div>
                        </div>
                    </mat-card-footer>
                </mat-card>
            </div>

        </div>

        <!-- CONTACT LIST -->
        
        <div class="home-body-right">
            <app-contact-list [users]="users" [currentUser]="user"></app-contact-list>
        </div>

        <div class="new-message">
            <i class="fas fa-edit fa-fw new-message-icon" placement="left" [ngbTooltip]="tipContent"></i>
            <ng-template class="new-message-tip" #tipContent>New Message</ng-template>
        </div>
    </div>
</div>